import { Badge, createStyles, Stack, Text, Title } from '@mantine/core';
import React, { FC, ReactNode } from 'react';

interface ProductTypeCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  disabled: boolean;
  onClick: () => void;
}

export const ProductTypeCard: FC<ProductTypeCardProps> = ({
  title,
  description,
  icon,
  disabled,
  onClick,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Stack
      spacing="xl"
      className={cx(classes.container, { disabled })}
      onClick={onClick}
    >
      <div className={classes.icon}>{icon}</div>

      <Stack spacing="xs" mb="sm">
        <Title
          order={4}
          data-testid={`product-type-card-title-${title}`}
          weight={600}
          align="center"
        >
          {title}
        </Title>
        <Text color="gray.5" weight={500} align="center" mb="sm">
          {description}
        </Text>
      </Stack>

      {disabled && <Badge className={classes.badge}>Coming Soon</Badge>}
    </Stack>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    paddingInline: theme.spacing.md,
    paddingBlock: theme.spacing.xl,
    border: `2px solid ${theme.colors.blue_gray[0]}`,
    borderRadius: theme.radius.md,
    transition: 'all 150ms linear',
    userSelect: 'none',
    cursor: 'pointer',
    maxWidth: 260,

    ':hover': {
      borderColor: theme.colors.blue_gray[1],
      boxShadow: '0px 11px 18px rgba(38, 50, 56, 0.1)',
    },

    '&.disabled': {
      pointerEvents: 'none',

      svg: {
        mixBlendMode: 'luminosity',
      },
    },
  },
  badge: {
    fontWeight: 500,
    alignSelf: 'center',
    marginTop: 'auto',
  },
  icon: {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',

    svg: {
      width: '100%',
      height: 'auto',
    },
  },
}));
